(function($) {

    $(document).ready(function() {
        let pageNumber = 1, myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
            paramObj = {
                url: myajax,
                action: 'projects_ajax',
                paged: 1,
            };

        let loading = false;

        function filters(paramObj) {
            $.ajax({
                url: paramObj.url,
                data: paramObj,
                type: 'post',
                beforeSend() {
                    $('.js-projects-ajax').css({ 'opacity': '0.3', 'pointer-events': 'none' });
                },
                complete() {
                    $('.js-projects-ajax').css({ 'opacity': '1', 'pointer-events': 'auto' });
                },
                success(result) {
                    // $('html, body').animate({ scrollTop: $('.posts').offset().top - 140 }, 500);
                    $('.js-projects-ajax').append(result);
                },
                error(result) {
                    dl.log('error');
                }
            });
        }

        if($('.js-projects-ajax').data('last') === paramObj.paged) {
            $('#loader').remove();
        }

        let loaderTriggered = false;

        $(window).on('scroll', function() {
            if ($('#loader').length && !loaderTriggered) {
            if (
                $(window).scrollTop() + $(window).height() >= $('#loader').offset().top &&
                $('.js-projects-ajax').data('last') >= paramObj.paged
            ) {
                loaderTriggered = true;
                loading = true;
                paramObj.paged = paramObj.paged + 1;
                filters(paramObj);
                loading = false;

                // Check if the loader should be removed
                if ($('.js-projects-ajax').data('last') <= paramObj.paged) {
                $('#loader').remove();
                }
            }
            }
        });

        // Reset loaderTriggered when new content is loaded and loader is still present
        $(document).ajaxComplete(function() {
            if ($('#loader').length) {
            loaderTriggered = false;
            }
        });

    });
})(jQuery);
